'use strict';

import React, { Component } from 'react';
import ValidationOverlay from '../../../adminModule/Menu/validationOverlay.jsx';
import Dialog from '../../../commonModules/interface/Dialog';
import $ from 'jquery';

class NewBoxToAdminAssociation extends Component{

     emptyTable = [
            {
                id: "",
                value: ""
            }
        ]
        state =  {
            //Initiate Default User
            msg: "",
            popupState: this.props.popupState,
            popupStateValidation: "overlay hidden",
            AdminEmail: "",
            adminlist: this.emptyTable,
            boxlist: this.emptyTable,
            BoxName: "",
            errmsg: "",
            url: ""
        }
    onValidation= (e) => {
        e.preventDefault();
        //Test if ok
        if (this.state.AdminEmail === '') {
            this.setState({errmsg: "AdminEmail can not be empty"});
            return;
        }
        if (this.state.BoxName === '') {
            this.setState({errmsg: "BoxName can not be empty"});
            return;
        }
        var adminId = "";
        for (var i = 0; i < this.state.adminlist.length; i += 1) {
            if (this.state.adminlist[i].id === this.state.AdminEmail) {
                adminId = this.state.adminlist[i].idObj;
            }
        }
        if (adminId === '') {
            this.setState({errmsg: "Admin Id can not be empty. Reload Page"});
            return;
        }
        var msg = "Record Box To Admin Association for box numéro " + this.state.BoxName + " à admin :  " + this.state.AdminEmail;
        var url = "admin/boxAttribution/new?box=" + this.state.BoxName + "&admin=" + adminId;
        //Active Pop up Security
        this.setState({popupStateValidation: "overlay", msg: msg, url: url});
    }
    onClose= (e) => {
        e.preventDefault();
        this.setState({popupState: "overlay hidden", popupStateValidation: "overlay hidden"});
        this.props.onCloseOverlay();
    }
    onValidationSucceed= () => {
        var boxlistUpdate = this.state.boxlist;
        for (var i = boxlistUpdate.length - 1; i >= 0; i--) {
            if (boxlistUpdate[i].id === this.state.BoxName) {
                boxlistUpdate.splice(i, 1);
            }
        }
        this.setState({
            msg: "",
            popupState: "overlay hidden",
            popupStateValidation: "overlay hidden",
            boxlist: boxlistUpdate,
            AdminEmail: "",
            BoxName: "",
            errmsg: "",
            url: ""
        });
        this.props.onCloseOverlay();
    }
    onChangeBoxName= (e) => {
        e.preventDefault();
        var value = e.target.value;
        this.setState({BoxName: value});
    }
    onChangeAdminEmail= (e) => {
        e.preventDefault();
        var value = e.target.value;
        this.setState({AdminEmail: value});
    }
    componentDidMount= () => {
        var methodName = 'new Association Box';
        var urlBoxFreeOfAssociation = "/box/list?status=free";

        this.serverRequest = $.get(urlBoxFreeOfAssociation, function(result) {
            console.log('[INFO],  reception des données  des associations de PAYGO ');
            console.log(result);
            var optionTmp = [];
            optionTmp.push({id: ""})
            try {
                var data = result; //var data = JSON.parse(result);

                for (var i = 0; i < data.content.length; i += 1) {
                    optionTmp.push({id: data.content[i].idBox})
                }
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({boxlist: optionTmp, boxlistValue: ""});
        }.bind(this));

        var methodName = 'get Admin List';
        var urlAdminList = "/admin/list";

        this.serverRequest = $.get(urlAdminList, function(result) {
            console.log('[INFO],  reception des données  des associations de PAYGO ');
            console.log(result);
            var optionTmp = [];
            optionTmp.push({id: ""})
            try {
                var data = result; //var data = JSON.parse(result);

                for (var i = 0; i < data.content.length; i += 1) {
                    optionTmp.push({id: data.content[i].email, idObj: data.content[i].id})
                }
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({adminlist: optionTmp, AdminEmail: ""});
        }.bind(this));
    }
    componentWillUnmount() {}
    render() {
      var valueList = this.state.boxlist;
      //Order by name
      valueList.sort(function(a, b) {
          if (a.value>b.value){
            return -1;
          }
          if (a.value < b.value){
            return 1;
          }
          return 0;
      });
        return (
            <Dialog 
                    title="Options"
                    block={this.props.popupState}
                    close={this.onClose }
                    >
                      
            <div className={this.props.popupState}>
                <div className="card">
                    <div className="card-header">
                        <h2>Associer une box en PAYGO
                            <small>à un administrateur</small>
                        </h2>
                    </div>

                    <div id="data-table-basic-header" className="bootgrid-header container-fluid">
                        {this.state.errmsg}
                        <div className="card-body card-padding">
                            <div className="row">
                                <div className="col-sm-12">
                                    <p className="c-black f-500 m-b-20">Numéro de box</p>
                                    <div className="form-group">
                                        <div className="fg-line">
                                            <select className="form-control" value={this.state.BoxName} onChange={this.onChangeBoxName}>
                                                {valueList.map(function(optionval) {
                                                    return <option key={optionval.id} value={optionval.id}>{optionval.id}</option>;
                                                })
}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <p className="c-black f-500 m-b-20">Admin Email</p>
                                    <div className="form-group">
                                        <div className="fg-line">
                                            <select className="form-control" value={this.state.AdminEmail} onChange={this.onChangeAdminEmail}>
                                                {this.state.adminlist.map(function(optionval) {
                                                    return <option key={optionval.id} value={optionval.id}>{optionval.id}</option>;
                                                })
}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <button className="btn btn-default btn-icon-text waves-effect" onClick={this.onValidation}>
                            <i className="zmdi zmdi-check-all"></i>
                            Enregister Association</button>
                        <button className="btn btn-default btn-icon-text waves-effect" onClick={this.onClose}>
                            <i className="zmdi zmdi-check-all"></i>
                            Cancel</button>
                    </div>
                </div>

                <ValidationOverlay msg={this.state.msg} popupStateButton={this.state.popupStateValidation} url={this.state.url} onValidation={this.onValidationSucceed}/>

            </div>
            </Dialog>
        );
    }
};
export default NewBoxToAdminAssociation

